module.exports = __webpack_public_path__ + "img/image-03.c1ef5a09.jpg";